export default "__VITE_ASSET__$0NS6DP6__"